export const REPORT = '/report'
export const REPORT_VIEW = `${REPORT}/:id`
